import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Input, message, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { SaveOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import regex from '../../constants/system.keys';
import LocationSearchLocationIQ from '../../components/LocationSearchLocationIQ';
import { onlyLettersAndNumbers } from '../../helpers/groupByCoors';
import {
  default as EmailTag,
  default as InputTag,
} from '../../components/InputTag';
import PhoneTag from '../../components/PhoneTag';
import * as SERVICE from '../../constants/service.types';
import { uniqRequestId } from '../../untils/unique';
import { EDEVICETYPE } from '../../constants';
import { socketEmitEvent } from '../../redux/actions';

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

const EditGatewayComponent = ({ onUpdate, data, onFinish, onCancel }) => {
  const { t } = useTranslation();
  const [isLoad, setIsLoad] = useState(false);
  const [form] = Form.useForm();
  const [requestId, setRequestId] = useState(new Date().getTime());
  const [isBlock, setIsBlock] = useState(false);
  const [address, setAddress] = useState({
    note: '',
  });
  const [alertUpdate, setAlertUpdate] = useState({
    visible: false,
    type: null,
    message: null,
  });
  const {
    updateDevice,
    namespace,
    accountByNamespace,
    listGpsLocation,
    listSpeakerSip,
  } = useSelector((state) => state);
  const dispatch = useDispatch();

  const [updateReturn, setUpdateReturn] = useState();
  useEffect(() => {
    if (updateDevice && updateDevice.requestId === requestId) {
      setUpdateReturn(updateDevice);
    }
  }, [requestId, updateDevice]);

  useEffect(() => {
    console.log('🚀 ~ EditGatewayComponent ~ data:', data);
    if (form && data) {
      const { name, serial, note, lat, lng, tags } = data;
      setAddress({
        note,
        lat,
        lng,
      });
      const contact = (data?.contact && JSON.parse(data?.contact)) || {};
      form.setFieldsValue({
        name,
        serial,
        location: note,
        tags: tags && tags !== ';' ? tags?.split(';') : [],
        accounts: contact?.accounts ? contact?.accounts?.split(';') : [],
        phones: contact?.phones ? contact?.phones?.split(';') : [],
        emails: contact?.emails ? contact?.emails?.split(';') : [],
        lat,
        lng,
      });
    }
    return () => {
      setAlertUpdate({ visible: false });
      form.resetFields();
    };
  }, [data, form]);

  useEffect(() => {
    if (namespace) {
      let dataBodyGps = {
        namespace,
        timeRequest: uniqRequestId(19, EDEVICETYPE.GPS),
        deviceType: EDEVICETYPE.GPS,
        page: 0,
        size: -1,
      };

      let dataObjGps = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBodyGps),
      };
      let dataBodySpeaker = {
        namespace,
        timeRequest: uniqRequestId(19, EDEVICETYPE.SPEAKER),
        deviceType: EDEVICETYPE.SPEAKER,
        page: 0,
        size: -1,
      };

      let dataObjSpeaker = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBodySpeaker),
      };

      dispatch(socketEmitEvent(dataObjGps));
      dispatch(socketEmitEvent(dataObjSpeaker));
    }
  }, [dispatch, namespace]);

  useEffect(() => {
    if (namespace) {
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACCOUNT_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, namespace]);

  const handleAddressChange = (address) => {
    form.setFieldsValue({
      location: address,
    });
    setAddress((state) => ({
      ...state,
      note: address,
    }));
  };

  const handleSelect = (address) => {
    form.setFieldsValue({
      location: address?.note ?? '',
    });
    setAddress(address);
  };

  useEffect(() => {
    if (data && updateReturn && updateReturn.serial === data.serial) {
      setIsLoad(false);
      if (updateReturn.isSuccess) {
        setUpdateReturn(null);
        form.resetFields();
        return onFinish();
      } else {
        setAlertUpdate({
          visible: true,
          type: 'warning',
          message: t('Something went wrong, try again!!'),
        });
      }
    }
  }, [data, form, onFinish, t, updateReturn]);

  const handleOnUpdate = (values) => {
    if (
      !values.tags ||
      (values.tags && onlyLettersAndNumbers(values.tags?.join('')))
    ) {
      const contact = {
        phones: values.phones?.join(';') || '',
        accounts: values.accounts?.join(';') || '',
        emails: values.emails?.join(';') || '',
      };

      const data = {
        name: values.name,
        note: values.location ?? '',
        serial: values.serial,
        lat: address.lat ?? 0,
        lng: address.lng ?? 0,
        contact: JSON.stringify({ ...contact }),
        tags: values.tags?.join(';')?.toLowerCase() || ';',
      };
      console.log('🚀 ~ UPDATE_DEVICE ~ dataBody:', data);
      const dataTimeRequest = new Date().getTime();
      setRequestId(dataTimeRequest);
      setIsLoad(true);
      return onUpdate(data, dataTimeRequest);
    } else {
      message.warning(t('Please enter only letters and numbers!'));
    }
  };

  return (
    <div className="edit-gateway-component">
      <Form
        form={form}
        {...layout}
        name="form_edit_gateway"
        onFinish={(values) => handleOnUpdate(values)}
      >
        <Form.Item
          name="name"
          label={t('Name')}
          rules={[
            {
              required: true,
              message: t('Please input the name of gateway!'),
            },
            {
              pattern: regex.isName,
              message: t('Please enter only letters and numbers!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="serial"
          label={t('Serial')}
          rules={[
            {
              required: true,
              message: t('Please input the namespace!'),
            },
            {
              pattern: regex.isName,
              message: t('Please enter only letters and numbers!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input disabled={true} />
        </Form.Item>

        <Form.Item
          name="location"
          rules={[
            {
              pattern: regex.isName,
              message: t('Please enter only letters and numbers!'),
            },
            {
              max: 200,
              message: t('Please input up to 200 characters!'),
            },
          ]}
          label={t('Location')}
        >
          <LocationSearchLocationIQ
            address={address.note}
            onChange={handleAddressChange}
            onAddressSelect={handleSelect}
            setIsBlock={setIsBlock}
          />
        </Form.Item>
        <Form.Item
          name="phones"
          className="edit-camera-email"
          label={t('Phone')}
          style={{ borer: '1px solid #434343', borderRadius: '2px' }}
        >
          <PhoneTag />
        </Form.Item>
        <Form.Item name="accounts" label={t('Account')}>
          <Select
            showSearch
            mode="multiple"
            placeholder={t('Select account')}
            optionFilterProp="children"
            filterOption={(input, option) => {
              const data =
                (option &&
                  option.children &&
                  option.children.props &&
                  option.children.props.children &&
                  option.children.props.children[0] &&
                  option.children.props.children[0].props &&
                  option.children.props.children[0].props.children) ||
                '';
              return (
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
          >
            {accountByNamespace?.map((d) => (
              <Select.Option key={d.accountId}>
                {d.fullName
                  ? `${d.phonenumber} (${d.fullName})`
                  : d.phonenumber}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="emails"
          className="edit-camera-email"
          label={t('Email')}
          style={{ borer: '1px solid #434343', borderRadius: '2px' }}
        >
          <EmailTag numberTag={3} nameAdd="Add email" />
        </Form.Item>
        <Form.Item
          name="tags"
          className="tags-device"
          label={t('Tag')}
          style={{ borer: '1px solid #434343', borderRadius: '2px' }}
        >
          <InputTag numberTag={3} nameAdd="Add tag" />
        </Form.Item>
        <div className="edit-gateway-alert">
          {alertUpdate.visible && (
            <Alert
              {...alertUpdate}
              showIcon
              closable
              onClose={() => setAlertUpdate({ visible: false })}
            />
          )}
        </div>
        <div className="btn-update-gateway">
          <Button onClick={() => onCancel()}>{t('Cancel')}</Button>
          <Form.Item shouldUpdate={true}>
            {() => (
              <Button
                icon={<SaveOutlined />}
                htmlType="submit"
                loading={isLoad}
                type="primary"
                disabled={
                  !form.isFieldsTouched(true) ||
                  form.getFieldsError().filter(({ errors }) => errors.length)
                    .length
                }
              >
                {t('Update')}
              </Button>
            )}
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default EditGatewayComponent;
